import { DuplicateSmall } from '@wix/wix-ui-icons-common';
import React, { FC, MouseEvent, useCallback } from 'react';

import { logger } from '../../../util/logger';
import s from './styles.scss';

type CopyIconProps = Readonly<{
  text: string;
  onSuccessCopy: () => void;
}>;

export const CopyIcon: FC<CopyIconProps> = ({ text, onSuccessCopy }) => {
  const onCopy = useCallback(
    async (e: MouseEvent) => {
      // do not trigger click on upper component
      // just write to clipboard text sent in props
      e.preventDefault();
      e.stopPropagation();

      try {
        await navigator.clipboard.writeText(text);
        onSuccessCopy();
      } catch (error) {
        logger.log({
          error,
          callParams: { text },
          message: `Failed to copy text`,
        });
      }
    },
    [text, onSuccessCopy],
  );

  return <DuplicateSmall className={s.copyIcon} onClick={onCopy} />;
};
